import { ReduxState } from 'app/redux/types';

import { SubmissionState } from '../types/submission';
import { selectSubmissionState } from './state';

// ---

export const selectSubmission = (state: ReduxState): SubmissionState => {
  return selectSubmissionState(state);
};
